import { animate, style, transition, trigger } from '@angular/animations'
import { Component, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationSkipped,
  NavigationStart,
  Router,
} from '@angular/router'
import { LaunchDarklyModule } from '@ftr/ui-feature-flags'
import { filter, switchMap, takeUntil, timer } from 'rxjs'

const hidden = { top: '-6px' }
const visible = { top: '0' }
const timing = '0.2s ease'

@Component({
  selector: 'ftr-app-navigation-loader',
  templateUrl: './app-navigation-loader.component.html',
  styleUrl: './app-navigation-loader.component.css',
  standalone: true,
  animations: [
    trigger('animateLoader', [
      transition(':enter', [style(hidden), animate(timing, style(visible))]),
      transition(':leave', [style(visible), animate(timing, style(hidden))]),
    ]),
  ],
  imports: [LaunchDarklyModule],
})
export class AppNavigationLoaderComponent {
  protected readonly showLoader = signal(false)

  constructor(private router: Router) {
    const startEvents$ = this.router.events.pipe(filter(event => event instanceof NavigationStart))
    const endEvents$ = this.router.events.pipe(
      filter(
        event =>
          event instanceof NavigationEnd ||
          event instanceof NavigationError ||
          event instanceof NavigationCancel ||
          event instanceof NavigationSkipped,
      ),
    )

    startEvents$
      .pipe(
        switchMap(() => timer(200).pipe(takeUntil(endEvents$))),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.showLoader.set(true))

    endEvents$.pipe(takeUntilDestroyed()).subscribe(() => this.showLoader.set(false))
  }
}
